import {SerializedStyles} from '@emotion/react';
import {Box, Collapse, css, useTheme} from '@mui/material';
import {DlMuiDynamicIcon, GetStylesFunction} from '@wallaby-ui/core';
import React, {CSSProperties, PropsWithChildren} from 'react';

interface Props {
  isOpen: boolean;
  setIsOpen: (v: boolean) => void;
  disabled?: boolean;
  style?: CSSProperties;
  headerStyle?: CSSProperties;
  title: string | JSX.Element;
  icon?: (setIsOpen: (b: boolean) => void) => JSX.Element;
  pinnedContent?: JSX.Element;
}
export const LightAccordion: React.FC<PropsWithChildren<Props>> = (props) => {
  const {isOpen, setIsOpen, disabled, headerStyle, title, icon, pinnedContent, children, ...extraProps} = props;
  const theme = useTheme();
  const muiStyles = getStyles({theme});
  return (
    <div {...extraProps}>
      <Box
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        minHeight='40px'
        paddingLeft='8px'
        paddingRight='8px'
        gap='8px'
        style={headerStyle}
      >
        {title}
        {icon ? (
          icon(setIsOpen)
        ) : (
          <DlMuiDynamicIcon
            data-name='accordion-collapse-button'
            data-collapsed={!isOpen}
            iconName={'expandMoreIcon'}
            useFixedViewBox
            onClick={() => setIsOpen(!isOpen)}
            style={{
              borderRadius: 4,
              transform: isOpen ? 'rotate(180deg)' : '',
              padding: 0,
            }}
            svgIconInputCss={muiStyles.icon}
            disabled={disabled}
            iconTitle={isOpen ? 'hai.miniScreen.hai.hide' : 'hai.miniScreen.hai.show'}
          />
        )}
      </Box>
      {pinnedContent}
      <Collapse in={isOpen} sx={{textAlign: 'left'}}>
        {children}
      </Collapse>
    </div>
  );
};
const getStyles: GetStylesFunction = (options) => ({
  icon: css`
    width: 24px;
    height: 24px;
  `,
  iconPointer: css`
    width: 24px;
    height: 24px;
    cursor: pointer;
  `,
});

type LightAccordionButtonHeader = {
  isOpen: boolean;
  setIsOpen: (v: boolean) => void;
  css?: SerializedStyles;
  iconTitle?: string;
};
export const LightAccordionButtonHeader: React.FC<PropsWithChildren<LightAccordionButtonHeader>> = ({
  isOpen,
  setIsOpen,
  iconTitle,
  children,
  ...extraProps
}) => {
  const theme = useTheme();
  const muiStyles = getStyles({theme});
  const defaultIconTitle = isOpen ? 'hai.miniScreen.hai.hide' : 'hai.miniScreen.hai.show';
  return (
    <Box
      display='flex'
      justifyContent='space-between'
      alignItems='center'
      padding='2px 8px'
      gap='10px'
      onClick={() => setIsOpen(!isOpen)}
      {...extraProps}
    >
      {children}
      <DlMuiDynamicIcon
        data-name='accordion-collapse-button'
        data-collapsed={!isOpen}
        iconName={'expandMoreIcon'}
        useFixedViewBox
        style={{
          borderRadius: 4,
          transform: isOpen ? 'rotate(180deg)' : '',
          padding: 0,
        }}
        svgIconInputCss={muiStyles.iconPointer}
        iconTitle={iconTitle ?? defaultIconTitle}
      />
    </Box>
  );
};
